import React from 'react';
import { OrderStatus } from '../../types';
import { STATUS_LABELS, STATUS_COLORS } from '../../constants/statuses';
interface StatusBadgeProps {
  status: OrderStatus;
  className?: string;
}
export function StatusBadge({
  status,
  className = ''
}: StatusBadgeProps) {
  return <span className={`
      inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium
      ${STATUS_COLORS[status]}
      ${className}
    `} data-id="element-224">
      {STATUS_LABELS[status]}
    </span>;
}